import { updateCart } from './cart';
import { drawerInit } from './cart-drawer';

/**
 * Get/update the cart
 * @return {Void}
 */
const getCart = () => {
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    success(cart) {
      const hasItems = cart.item_count ? true : false;

      $('.link-cart').toggleClass('has-items', hasItems);
      $('.js-cart-count').toggleClass('hidden', !hasItems);
      $('.js-cart-count').text(cart.item_count);

      updateCart('/cart?view=ajax');
    },
  });
};

$(document).on('submit', '.js-ajax-form', function(event) {
  event.preventDefault();

  const $form = $(this);
  const data = $form.serialize();

  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    dataType: 'json',
    data,
    success(item) {
      drawerInit(item);
      getCart();
    },
    error(err) {
      alert(err.responseJSON.description);
    },
  });
});

$(document).on('change', '.js-ajax-form .js-line-item-quantity', function(event) {
  const $this = $(this);
  const $form = $this.closest('.js-ajax-form');

  $.ajax({
    url: '/cart/update.js',
    type: 'POST',
    dataType: 'json',
    data: $form.serialize(),
    success(cart) {
      getCart();
    },
  });
});
